/* eslint-disable @next/next/no-async-client-component */
"use client";
import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";

const socialMediaShare = [
  {
    id: 0,
    link: "https://t.me/share/url?url=",
    icon: "/singlBlogImg/telegram.png",
  },
  {
    id: 1,
    link: "#",
    icon: "/singlBlogImg/copy-text-svgrepo-com.svg",
    isCopy: true,
  },
];

const Tags = ({ tagsProps }: { tagsProps: any }) => {
  // console.log('tagsProps==>' , tagsProps);
  
  const [currentUrl, setCurrentUrl] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setCurrentUrl(window.location.href);
  }, []);

  const copyToClipboard = () => {
    const currentUrl = window.location.href;
    navigator.clipboard.writeText(currentUrl);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  return (
    <>
      <div className=" flex xl:flex-row flex-col shadow-md justify-between popular-item-gradient xl:items-center items-start w-full gap-6 p-5 mb-6 mx-auto overflow-hidden rounded-xl">
        <div className="flex flex-wrap justify-start items-center gap-3 ">
          <span className="text-white mr-[10px] flex justify-center items-center gap-1">
            <div className="size-[20px] relative">
              <Image
                src={"/singlBlogImg/price-tag.png"}
                alt="user icon"
                fill
                className="w-full h-full object-cover"
              />
            </div>
            Tags:
          </span>
          <ul className="flex flex-wrap justify-start py-3 sm:py-0 items-center gap-4 sm:gap-3 text-white xl:max-w-[600px] overflow-x-hidden h-full sm:h-[56px] ">
            {tagsProps.map(
              (tag: {
                slug: string ;
                id: React.Key | null | undefined;
                link: string;
                name: string | null | undefined;
              }) => (
                <li key={tag?.id} className=" sm:mr-[8px] ">
                <Link
                    href={`/blog/?tags=${tag?.id}`}
                    className='whitespace-nowrap rounded  text-[13px] xl:text-[16px] py-[9px] '
                  >
                    # {tag?.name}
                  </Link>
                </li>
              )
            )}
          </ul>
        </div>
        <div className="flex justify-center items-center gap-3 ">
          <span className="text-white mr-[10px] flex justify-center items-center gap-1">
            Share:
          </span>
          <ul className="flex justify-center items-center gap-3 text-white">
            {socialMediaShare.map((i, j) => (
              <li key={j} className="mr-[4px]">
                {i.isCopy ? (
                  <button
                    onClick={copyToClipboard}
                    className="bg-[#0d6efd] text-[#0d6efd] rounded-full text-[16px] size-[35px] flex items-center justify-center hover:text-white transition-all duration-300 ease-linear hover:-translate-y-2"
                  >
                    <div className="size-[16px] relative">
                      <Image
                        src={i.icon}
                        alt="copy icon"
                        fill
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </button>
                ) : (
                  <Link
                    href={`${i.link}${currentUrl}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-[#0d6efd] text-[#0d6efd] rounded-full text-[16px] size-[35px] flex items-center justify-center hover:text-white transition-all duration-300 ease-linear hover:-translate-y-2"
                  >
                    <div className="size-[16px] relative">
                      <Image
                        src={i.icon}
                        alt="share icon"
                        fill
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
      {copied && (
        <div
          id="copy-modal"
          className="fixed right-0 left-0 bottom-10 mx-auto bg-[#078a50] text-white py-2 px-4 rounded w-[100px] text-center z-20"
        >
          Copied
        </div>
      )}
    </>
  );
};

export default Tags;